import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // より確実にトップにスクロール
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
    // 念のため、少し遅延を入れて再度スクロール
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
